/**
 * Consolidations of an agreement's portfolios (TRADE-CONS step 1a, migration 0128; backend
 * `routers/portfolio_consolidations.py`). Read by `portfolios.read`; changed by
 * `portfolios.consolidate` — direct and audited, no maker-checker (Pedro S1-Q2).
 */
import { api } from './client';
import type { UUID } from './types';

export interface ConsolidationMember { link_id: UUID; ref: string; label: string }
export interface Consolidation {
  id: UUID;
  agreement_id: UUID; agreement_label: string;
  name: string;
  members: ConsolidationMember[];
  updated_at: string;
  /** 1b (0129): the model it follows (its members follow it) */
  model_id: UUID | null; model_name: string | null;
}
/** The consolidation a linked portfolio is in, as the portfolio rows carry it (with its model, 1b). */
export interface ConsolidationRef { id: UUID; name: string; model_id: UUID | null; model_name: string | null }
/** The model a portfolio in no consolidation follows (1b). */
export interface ModelRef { id: UUID; name: string }

export const portfolioConsolidationsApi = {
  list: (agreementId?: UUID) =>
    api.get<{ items: Consolidation[]; total: number }>(
      `/portfolio-consolidations${agreementId ? `?agreement_id=${encodeURIComponent(agreementId)}` : ''}`),
  create: (p: { agreement_id: UUID; name: string; link_ids: UUID[] }) =>
    api.post<Consolidation>('/portfolio-consolidations', p),
  update: (id: UUID, p: { name: string; link_ids: UUID[] }) =>
    api.put<Consolidation>(`/portfolio-consolidations/${id}`, p),
  remove: (id: UUID) => api.delete<void>(`/portfolio-consolidations/${id}`),
};

/** 1b (0129, `portfolios.models`): the model a consolidation / a portfolio in none follows. */
export const portfolioModelsApi = {
  setPortfolio: (linkId: UUID, modelId: UUID | null) =>
    api.put<{ model: ModelRef | null }>(`/portfolio-models/portfolio/${linkId}`, { model_id: modelId }),
  setConsolidation: (consolidationId: UUID, modelId: UUID | null) =>
    api.put<{ model: ModelRef | null }>(`/portfolio-models/consolidation/${consolidationId}`, { model_id: modelId }),
};
